export function classNames(classes: Record<string, boolean> | string[]): string {
  if (Array.isArray(classes)) {
    return classes.join(' ')
  }

  return Object.entries(classes)
    .reduce((acc, [className, expression]) => {
      if (expression) acc.push(className)
      return acc
    }, [])
    .join(' ')
}
